import styled from "styled-components";

const Asocijator = () => {
  return <div>Asocijator</div>;
};

export default Asocijator;
